<script lang="ts">
	import type { Device } from 'src/types/Device';
		import { getDeviceStatus, getDeviceSettings } from 'src/stores/device-runtime/status-selectors';
	import DistanceMainTab from 'src/components/Distance/DistanceMainTab.svelte';
	import { getDeviceChartsConfig } from 'src/components/Chart/chart_config';
	import type { ChartConfigInterface } from 'src/types/Chart';
	import { useNavigateToHistoryStatisticsTab } from 'src/components/Sidepanel/useNavigateToHistoryStatisticsTab';
	import DeviceViewStateWrapper from 'src/components/Sidepanel/DeviceViews/DeviceViewStateWrapper.svelte';
	import LastReporterV2 from 'src/components/Drawer/LastReporterV2.svelte';
	import DeviceLabelList from 'src/components/Sidepanel/DeviceViews/DeviceLabelList.svelte';
	import {
		createGen1CombinedLabelList,
		createGen1StatusLabels,
		getGen1DeviceStatuses,
	} from '../../../Gen1/gen1-main-helpers';
	import { devices_config } from '@devices/index';

	export let device: Device;

	let timerLabels: Record<string, any> = {};

	const { navigateToHistoryStatisticsTab } = useNavigateToHistoryStatisticsTab();

	const deviceChartsConfig: ChartConfigInterface[] = getDeviceChartsConfig(device);

	const handleOnClickThumbChart = (event: CustomEvent | Event) => {
		navigateToHistoryStatisticsTab();
	};

	$: deviceConfig = devices_config?.[device?.type];

	$: statusStore = getDeviceStatus(device?.id);
	$: status = $statusStore;
	$: settingsStore = getDeviceSettings(device?.id);
	$: settings = $settingsStore;

	$: _statuses = getGen1DeviceStatuses(status, device, settings, deviceConfig);
	$: labelList = createGen1StatusLabels(_statuses, device);

	$: combinedLabelList = createGen1CombinedLabelList(timerLabels, labelList);
</script>

<DeviceViewStateWrapper {device}>
	<div class="label-list-wrapper mb-s" slot="staticTop">
		<DeviceLabelList labelList={combinedLabelList} />
	</div>

	<div class="flex-full-height align-items-center justify-content-center" slot="content">
		<DistanceMainTab {device} {deviceChartsConfig} {handleOnClickThumbChart} />
	</div>

	<div class="flex-full-height justify-content-end" slot="staticBottom">
		{#if !device.shared}
			<LastReporterV2 class="mb-s" {device} />
		{/if}
	</div>
</DeviceViewStateWrapper>
